import { FileDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface DataTableExportButtonProps {
  onExport: () => void;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

export function DataTableExportButton({
  onExport,
  className,
  disabled,
  isLoading = false,
}: DataTableExportButtonProps) {
  const handleClick = () => {
    onExport();
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            onClick={handleClick}
            disabled={(disabled ?? false) || isLoading}
            className={className}
          >
            {isLoading ? <Spinner className="h-4 w-4" /> : <FileDown className="h-4 w-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Export to CSV</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
